import React from "react";
import { ModalBuilder, Table } from "@redriver/cinnamon";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { deleteNote } from "../actions";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";

const DeleteNote = ({
  as: As = Table.MenuItem,
  sheetId,
  noteId,
  onSubmitted,
}) => {
  const { t } = useTranslation("sheetHeader");

  return (
    <ImpersonatedUserPermissionCheck
      target={Targets.SheetNote}
      action={Actions.Delete}
    >
      <ModalBuilder
        withForm
        submitAction={deleteNote}
        submitParams={{ sheetId, noteId }}
        onSubmitted={onSubmitted}
        renderTrigger={(showModal) => (
          <As onClick={showModal}>{t("Delete")}</As>
        )}
        renderModal={(modalProps) => (
          <TranslatedModal.Delete
            {...modalProps}
            header={t("Delete_Note")}
            size="tiny"
          >
            {t("Delete_note_confirmation")}
          </TranslatedModal.Delete>
        )}
      />
    </ImpersonatedUserPermissionCheck>
  );
};

export default DeleteNote;
